import { useContext } from "react"
import { Grid, MenuItem } from "@material-ui/core"
import { Field, useFormikContext } from "formik"
import { applicationContext } from "helpers/services"
import { ReferenceData, TypeInfo } from "helpers/enums"
import { KeyValuePair } from "helpers"
import { SCAutocomplete } from 'components';
import { TextField } from "formik-material-ui"
import { Alert, AlertTitle } from "@material-ui/lab"

interface IProps {
    ticketTypeId: string
    schema: any
}

let UpdateHeaderDataForm = (props: IProps) => {
    let { referenceData, ticketTypes, issueServiceTypes, searchReporters } = useContext(applicationContext);

    let form = useFormikContext<typeof props.schema>();

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        label="Title"
                        name="title"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </Grid>

                <Grid item xs>
                    <Field
                        component={TextField}
                        select
                        label="Supplier"
                        name="supplier"
                        variant="outlined"
                        size="small"
                        fullWidth
                    >
                        {referenceData
                            .getByKey(ReferenceData.Supplier)?.values
                            .map((x: KeyValuePair<string, string>) => <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)
                        }
                    </Field>
                </Grid>

                <Grid item xs>
                    <SCAutocomplete
                        inputLabel="Reporter"
                        variant="outlined"
                        value={{
                            value: form.values.reporter,
                            label: form.values.reporterName
                        }}
                        doSearch={async (value: string, etag: number) => await searchReporters(value, etag)}
                        onChange={(value: any) => {
                            form.setFieldValue('reporter', value?.value || '');
                            form.setFieldValue('reporterName', value?.label || '');
                        }}
                        error={Boolean(form.touched.reporter && form.errors.reporter)}
                        helperText={form.errors.reporter as any || 'Type in the name of a customer or colleague'}
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <Field
                        component={TextField}
                        select
                        name="ticketTypeId"
                        label="Ticket type"
                        variant="outlined"
                        fullWidth
                        onChange={(e: any) => {
                            form.setFieldValue("ticketTypeId", e.target.value);
                            form.setFieldValue("ticketTypeInfo", ticketTypes.getValueByKey(e.target.value, 'id', 'typeInfo'));
                            form.setFieldValue("issueServiceType", '');
                        }}
                    >
                        {ticketTypes.map(x => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Field>
                </Grid>
                <Grid item xs>
                    {ticketTypes.getValueByKey(form.values.ticketTypeId, 'id', 'typeInfo') === TypeInfo.Delivery &&
                        <Field
                            component={TextField}
                            select
                            name="issueServiceType"
                            label="Issue service type"
                            variant="outlined"
                            fullWidth
                        >
                            {issueServiceTypes.map(issue =>
                                <MenuItem key={issue.key} value={issue.key}>{issue.value}</MenuItem>)
                            }
                        </Field>
                    }
                </Grid>

                {props.ticketTypeId !== form.values.ticketTypeId &&
                    <Grid item xs={12}>
                        <Alert severity="warning" title="Attention">
                            <AlertTitle>By changing ticket type some information will be cleared. You can see the old data from the "Activities" tab</AlertTitle>
                        </Alert>
                    </Grid>
                }
            </Grid>
        </>
    )
}

export default UpdateHeaderDataForm